import { render, staticRenderFns } from "./ClientList_Export.vue?vue&type=template&id=51cedb78&"
import script from "./ClientList_Export.vue?vue&type=script&lang=js&"
export * from "./ClientList_Export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports